/** Строка действий дашборда оператора (04.09, владелец: «убрать приветствие
 *  и в этой строке оставить кнопку „я на месте“ и добавить кнопки „доп
 *  работа“ и „покупка“»). Три компактные кнопки одного стиля: «Я на месте»
 *  (orange → green «на месте»), «Доп.работа» (pink — канон допов, открывает
 *  ProposeExtraSheet), «Покупка» (lime — канон покупок, PurchaseSheet) +
 *  счётчик игр справа. «Я на месте» теперь ЖИВОЙ: GET /api/attendance/status
 *  при монтировании (только если выбранная дата = сегодня) и POST
 *  /api/attendance/arrive по тапу (раньше — голый useState, ничего не
 *  сохранял). Ниже — свои покупки за день (MyPurchases). Тост — локальный
 *  (паттерн AnketaTab). Вынесено из OperatorScreen.tsx: он в базлайне рэтчета
 *  (399 строк) и расти не может.
 *  04.09 (ревью): «Я на месте» показываем ТОЛЬКО на бизнес-сегодня (иначе
 *  кнопка на другом дне показывала бы сегодняшнее состояние и отмечала явку
 *  за сегодня). GET /status у мультироли (ОО/ЕО с extra_role operator)
 *  отвечает формой ОО {date, operators:[{operator_id, att_status}]}, а не
 *  {status} — ищем свою запись по operatorId (= user.staffId из OperatorScreen). */
import { useCallback, useEffect, useState } from "react";
import { api } from "../../api/client";
import { todayBusiness } from "../../utils/date";
import { Check } from "./icons";
import { MyPurchases } from "./MyPurchases";
import { ProposeExtraSheet } from "./ProposeExtraSheet";
import { PurchaseSheet } from "./PurchaseSheet";
import css from "./dashActions.module.css";

type Sheet = "extra" | "buy" | null;
/* обе формы ответа /api/attendance/status: оператор — {status}; ОО/ЕО — {operators[]} */
interface AttStatus { status?: string; operators?: { operator_id?: string; att_status?: string | null }[] }
const isArrived = (r: AttStatus, staffId: string): boolean =>
  Array.isArray(r.operators)
    ? r.operators.some((o) => o.operator_id === staffId && o.att_status === "arrived")
    : r.status === "arrived";

export function DashActions({ date, count, operatorId, onReload, onSideReload }: {
  date: Date; count: number; operatorId: string; onReload: () => void; onSideReload: () => void;
}) {
  const isToday = date.getTime() === todayBusiness().getTime();
  const [present, setPresent] = useState(false);
  const [presBusy, setPresBusy] = useState(false);
  const [toast, setToast] = useState<{ msg: string; err: boolean } | null>(null);
  const [sheet, setSheet] = useState<Sheet>(null);
  const [purTick, setPurTick] = useState(0);
  const showToast = useCallback((msg: string, err = false) => {
    setToast({ msg, err });
    window.setTimeout(() => setToast((t) => (t && t.msg === msg ? null : t)), 3000);
  }, []);

  /* статус явки — по бизнес-сегодня (сервер считает «сегодня» сам, UTC+5) */
  useEffect(() => {
    if (!isToday) return;
    let alive = true;
    api<AttStatus>("/api/attendance/status")
      .then((r) => { if (alive) setPresent(isArrived(r, operatorId)); })
      .catch((e: unknown) => console.warn("attendance/status", e));
    return () => { alive = false; };
  }, [isToday, operatorId]);

  const arrive = async () => {
    if (presBusy) return;
    setPresBusy(true);
    try { await api("/api/attendance/arrive", { method: "POST", retries: 0 }); setPresent(true); }
    catch (e) { console.warn("attendance/arrive", e); showToast("Не удалось отметиться — попробуй ещё раз", true); }
    finally { setPresBusy(false); }
  };

  return (
    <>
      <div className={css.row}>
        {!isToday ? null : present ? (
          <span className={`${css.act} ${css.actOn}`}><Check /> на месте</span>
        ) : (
          <button type="button" className={css.act} disabled={presBusy} onClick={() => void arrive()}><Check /> я на месте</button>
        )}
        <button type="button" className={`${css.act} ${css.actPink}`} onClick={() => setSheet("extra")}>🔧 Доп.работа</button>
        <button type="button" className={`${css.act} ${css.actLime}`} onClick={() => setSheet("buy")}>🧾 Покупка</button>
        <span className={css.count}><b>{count}</b> игр</span>
      </div>
      <MyPurchases date={date} operatorId={operatorId} tick={purTick} onToast={showToast} />
      <ProposeExtraSheet open={sheet === "extra"} date={date} onClose={() => setSheet(null)}
        onDone={() => { setSheet(null); showToast("Заявка отправлена"); onSideReload(); onReload(); }} />
      <PurchaseSheet open={sheet === "buy"} date={date} onClose={() => setSheet(null)}
        onDone={() => { setSheet(null); showToast("Покупка отправлена ОО на подтверждение"); setPurTick((n) => n + 1); }} />
      {toast ? <div className={`${css.toast} ${toast.err ? css.toastErr : ""}`}>{toast.msg}</div> : null}
    </>
  );
}
